import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import {
  IntegrationEnum,
  IntegrationStatus,
} from 'models/InternalIntegrationSetting';
import useAppUser from '../../../../hooks/useAppUser';

const useHostfullyDevices = () => {
  const { isEmployeeManager } = useAppUser();
  const { data } = useFetchIntegrationAgencySettings({
    enumId: IntegrationEnum.HOSTFULLYDEVICES,
    enabled: isEmployeeManager,
  });

  const isHostfullyDevicesEnabled =
    (isEmployeeManager &&
      data?.agencySettings?.status === IntegrationStatus.ACTIVE) ||
    false;

  return { isHostfullyDevicesEnabled };
};

export default useHostfullyDevices;
